<template>
	<img src='../../../assets/chevron-down.svg' />
</template>

<script>
export default {
	name : "OpenIndicator"
}
</script>